import classnames from 'classnames';
import React, { useMemo } from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import { ImagePanelFeatureType } from '@/types';
import './style.less';

interface AdjustWrapProps {
    name: string;
    icon: string;
    cardTypeList: ImagePanelFeatureType[];
    curType: ImagePanelFeatureType | '';
    setCurType: (type: ImagePanelFeatureType | '') => void;
    isBaseType?: boolean;
    onShowChange: (
        cardType: ImagePanelFeatureType | '',
        isBaseType: boolean,
        isShow: boolean,
        e: React.MouseEvent,
    ) => void;
    children?: React.ReactNode;
}

const AdjustItemWrap: React.FC<AdjustWrapProps> = ({
    name,
    icon,
    cardTypeList,
    curType,
    setCurType,
    isBaseType = false,
    onShowChange,
    children,
}) => {
    const isShow = useMemo(() => {
        return !!curType && cardTypeList.includes(curType);
    }, [cardTypeList, curType]);

    return (
        <div className={classnames('b-list-menu', { 'b-list-menu--active': isShow })}>
            <div
                className="b-list-menu__header"
                onClick={(e) => {
                    onShowChange(curType, isBaseType, !isShow, e);
                }}
            >
                <div className="b-list-menu__left">
                    {/* icon */}
                    <IconFont fontSize={16} name={icon} />
                    {/* 菜单名 */}
                    <span className="b-list-menu__name">{name}</span>
                </div>
                <div
                    className={classnames('b-list-menu__right', {
                        rotate: isShow,
                    })}
                >
                    {/* 下拉箭头 */}
                    <IconFont fontSize={16} name="ChevronDownBold" />
                </div>
            </div>

            {isShow && children ? <div className="b-list-menu__footer">{children}</div> : null}
        </div>
    );
};

export default AdjustItemWrap;
